import { Component } from 'preact';

import LazyBackground from '../lazy-background';

import FadeCard from '../fade-card';
import OptionCard from '../cards/option-card';

import { USER_ID } from '../../constants';
import { createNewUser } from '../../utils/api';

import { trackEvent, trackScreen } from '../../utils/tracking';

const WELCOME_MESSAGE = `Before we get our feet wet, we'd love to know a little about you!`;

const OPTIONS = [
	{
		question: 'What is your gender?',
		id: 'gender',
		options: [
			{ label: 'Male', value: 'male' },
			{ label: 'Female', value: 'female' },
			{ label: 'Prefer not to answer', value: 'na' }
		],
		gtmCode: 'demo_gender_visit'
	},
	{
		question: 'How old are you?',
		id: 'age',
		options: [
			{ label: '18-24', value: '18-24' },
			{ label: '25-37', value: '25-37' },
			{ label: '38-52', value: '38-52' },
			{ label: '53-66', value: '53-66' }
		],
		gtmCode: 'demo_age_visit'
	},
	{
		question: 'What region are you from?',
		id: 'region',
		options: [
			{ label: 'West', value: 'west' },
			{ label: 'Mountain', value: 'mountain' },
			{ label: 'Central', value: 'central' },
			{ label: 'East', value: 'east' }
		],
		gtmCode: 'demo_region_visit'
	}
];

export default class Intro extends Component {

	state = {
		submitting: false
	}

	data = {}

	set = (id, value) => {
		this.setState({ [id]: value })
	}

	goToNext = () => this.fadeCard.nextCard()

	submit = async () => {
		// disable spam clicking
		if(!this.state.submitting) {
			this.setState({ submitting: true });
			let userId = localStorage.getItem(USER_ID);
			// if(!userId) {
				let userData = Object.keys(this.state).reduce( (data, key) => {
					if(key !== 'submitting') {
						data[key] = this.state[key];
					}
					return data;
				}, {});
				let newUserId = await createNewUser(userData);
				localStorage.setItem(USER_ID, newUserId);
				window.moen_social_tracking.event("Moen - Water Census Survey - Started");
				this.props.finish();
			// }
			//
		}
	}

	cardChange = (index, max) => {
		if(max - 1 === index ) {
			return;
		}
		let event = OPTIONS[index+1].gtmCode;
		trackScreen(event);
		// trackEvent();
	}

	render() {
		const { handleChange, set, submit } = this;
		const { selected, submitting } = this.state;
		return (
			<div className="intro-card">
				<LazyBackground image={'assets/intro-min.jpg'} />
				<div className="content-card">
					<h1>{WELCOME_MESSAGE}</h1>
					<FadeCard
						ref={ node => this.fadeCard = node }
						counter={true}
						counterDelimiter={'of'}
						finish={submit}
						change={this.cardChange}
					>
						{
							OPTIONS.map( (option, index) => {
								return (
									<OptionCard
										id={option.id}
										index={index}
										question={option.question}
										options={option.options}
										next={this.goToNext}
										set={set}
										submitting={submitting}
										active={this.state[option.id]}
									/>
								)
							})
						}

						{/*<button onClick={this.goToNext}>NEXT</button>*/}
					</FadeCard>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/intro/index.js